export const getEnv = <T extends keyof NodeJS.ProcessEnv>(env: T): NodeJS.ProcessEnv[T] => process.env[env];
